<template>
    <div class="membody realwrap" v-if="isload">
        <div class="memtop">
            <div class="topleft">
                <div class="avator">
                    <a href="#" @click="isshowavator=true"><img :src="$common.getface($store.state.face)" /></a>
                </div>
                <div class="basicinfo">
                    <dl>
                        <dt><router-link to="/member/profile">{{$store.state.showname}}</router-link></dt>
                        <dd><router-link v-if="me.mobile && $store.state.showname!=me.mobile" to="/member/mobile"><span>{{$common.markmobile($store.state.mymobile)}}</span></router-link><span class="basicinfomore"><router-link to="/member/account">{{$common.dicword('accountset')}}</router-link>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="#" @click="$common.logout()">{{$common.dicword('logout')}}</a></span></dd>
                    </dl>
                </div>
            </div>
            <div class="topright">
                <dl>
                    <dd v-for="item in mynav" v-if="item.isshortcut==1" :key="item.id"><router-link :to="item.url"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link></dd>
                </dl>
            </div>
        </div>
        <div class="memmain">
            <div class="memnav">
                <dl>
                    <dd v-for="item in mynav" :key="item.id"><router-link :to="item.url" :class="{cs:(item.kv==curnavkv)}"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link></dd>
                </dl>

            </div>

            <div class="memcon">
                <div class="memsubnav">
                    <div class="navline"></div>
                    <div class="memsubproject" ref="subnavwrap" v-show="!issmall" v-finger:swipe="navmoveswipe">
                        <div class="navarrow" v-if="isshownavarrow"><a href="#" @mousedown="navmove(-5)" v-finger:tap="navmoveprev" @mouseout="isnavmove=false" @mouseup="isnavmove=false"><i class="iconfont icon-arrow-left-bold"></i></a><a href="#" @mousedown="navmove(5)" v-finger:tap="navmovenext" @mouseout="isnavmove=false" @mouseup="isnavmove=false"><i class="iconfont icon-arrow-right-bold"></i></a></div>
                        <dl v-if="hasnavsub" ref="subnavreal" :style="{'transform':'translateX(-'+subnavmovex+'px)'}">
                            <dd v-for="item in mynavsub" :key="item.id"><a href="#" :class="{cs: ( navsub==item.kv)}" @click="showsub(item.kv)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                        </dl>
                        <dl v-else-if="hasnavpro" ref="subnavreal" :style="{'transform':'translateX(-'+subnavmovex+'px)'}">
                            <dd v-for="(item,index) in listproject" :key="item.id"><a href="#" :class="{cs: ( indexproject==index)}" @click="selectproject(index)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                        </dl>
                        <dl v-else ref="subnavreal" :style="{'transform':'translateX(-'+subnavmovex+'px)'}">
                            <dd>
                                <router-link :to="c_navmain.url" class="cs">{{$common.langinfo(c_navmain.title,c_navmain.title_en)}}</router-link>
                                <template v-if="subtitle">
                                    <i class="iconfont icon-fanye1"></i>
                                    {{subtitle}}
                                </template>
                            </dd>
                        </dl>
                        <div class="navbtn" v-if="hassave"><a href="#" @click="save">{{$common.dicword('save')}}</a></div>
                    </div>

                    <div class="memsubproject2" v-if="issmall">
                        <div class="navbtn" v-if="hassave"><a href="#" @click="save">{{$common.dicword('save')}}</a></div>
                        <div class="m2item">
                            <a href="#" class="m2select" @click.stop.prevent="showmorenav(true)"><i :class="['iconfont',c_navmain.icon]"></i>{{$common.langinfo(c_navmain.title,c_navmain.title_en)}}</a>
                            <transition name="fade">
                                <div class="memmainnavmore" v-show="shownavmain">
                                    <dl v-if="$common.basic.isarrayexist(mynav)">
                                        <dd v-for="item in mynav" :key="item.id">
                                            <router-link :to="item.url" :class="{cs:(item.kv==curnavkv)}"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link>
                                        </dd>
                                    </dl>
                                </div>
                            </transition>
                        </div>

                        <div class="m2item" v-if="$common.basic.isarrayexist(listproject)">
                            <i class="iconfont icon-fanye1"></i>
                            <a href="#" class="m2select" @click.stop.prevent="showmorenav(false,true)">{{$common.langinfo(c_subnavtop.title,c_subnavtop.title_en)}}</a>
                            <template v-if="hasnavsub">
                                <transition name="fade" v-if="$common.basic.isarrayexist(mynavsub)">
                                    <div class="memsubnavmore" v-show="shownavsub">
                                        <dl>
                                            <dd v-for="item in mynavsub" :key="item.id"><a href="#" :class="{cs: ( navsub==item.kv)}" @click="showsub(item.kv)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                                        </dl>
                                    </div>
                                </transition>
                            </template>
                            <template v-else>

                                <transition name="fade" v-if="$common.basic.isarrayexist(listproject)">
                                    <div class="memsubnavmore" v-show="shownavsub">
                                        <dl>
                                            <dd v-for="(item,index) in listproject" :key="item.id"><a href="#" :class="{cs:indexproject==index}" @click="selectproject(index)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                                        </dl>
                                    </div>
                                </transition>
                            </template>

                        </div>
                        <div class="m2item" v-if="subtitle">
                            <i class="iconfont icon-fanye1"></i>
                            <span class="m2select">{{subtitle}}</span>
                        </div>
                    </div>

                    <div class="memsearch">
                        <div class="left">
                            <el-select v-if="c_options.showsch && $common.basic.isarrayexist(listsch)" v-model="myoption.schid" size="mini" class="memselect" @change="selectsch">
                                <el-option :label="$common.dicword('allcourse')" :value="-1"></el-option>
                                <el-option v-for="item in listsch" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                            </el-select>

                            <template v-if="c_options.hasgroup">

                                <el-cascader ref="casgroup" v-model="casgroupvalue" v-if="c_showschool && c_showgroup" :options="schoollist" size="mini" class="memselect" popper-class="calevel"
                                             :props="casoptiongroup" :show-all-levels="false" :placeholder="$common.dicword('allclass')" @change="groupchange"></el-cascader>

                                <el-select v-else-if="c_showschool" v-model="myoption.schoolid" size="mini" class="memselect" @change="selectcompany">
                                    <el-option v-for="item in schoollist" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                                </el-select>
                                <el-select v-else-if="c_showgroup" v-model="myoption.groupid" size="mini" class="memselect" @change="selectgroup">
                                    <el-option v-if="c_options.anygroup" :label="$common.dicword('allclass')" :value="-1"></el-option>
                                    <el-option v-for="item in grouplist" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                                </el-select>
                            </template>
                            <template v-if="c_options.hascourse && c_options.showcourse">
                                <el-cascader ref="caslevel" v-model="caslevelvalue" v-if="$common.basic.isarrayexist(listlevel)" :options="listlevel" size="mini" class="memselect" popper-class="calevel"
                                             :props="casoption" :show-all-levels="false"
                                             :clearable="c_options.anycourse" :placeholder="$common.dicword('allcourse')" @change="levelchange"></el-cascader>
                            </template>

                            <template v-else-if="hasnavsub && c_options.hasproject">
                                <el-cascader v-if="$common.basic.isarrayexist(listproject)" v-model="caslevelvalue" ref="caslevel" :options="listproject" size="mini" class="memselect" popper-class="calevel"
                                             :props="casoption" :show-all-levels="false"
                                             :clearable="true" :placeholder="$common.dicword('allcourse')" @change="projectchange"></el-cascader>
                            </template>
                        </div>


                        <div class="right" v-if="c_options.haskw&&!issmall">
                            <el-input :placeholder="$common.dicword('keyword')" size="mini" suffix-icon="el-icon-search" v-model="myoption.kw" @change="optionsupdate"></el-input>
                        </div>
                    </div>
                    <template v-if="!hasnavsub && c_options.haslevel && $common.basic.isarrayexist(listproject)">
                        <div class="courselevel" v-if="listproject[indexproject].x_children.length>1 && !issmall">
                            <a href="#" :class="{cs:listproject[indexproject].x_index==-1}" @click="selectlevel(-1)">{{$common.dicword('allcourse')}}</a>
                            <a v-for="(item,index) in listproject[indexproject].x_children" :key="item.id" href="#" :class="{cs:listproject[indexproject].x_index==index}" @click="selectlevel(index)">{{$common.langinfo(item.title,item.title_en)}}</a>
                        </div>
                    </template>
                </div>


                <slot></slot>
            </div>
        </div>
        <el-dialog v-if="isshowavator" :visible.sync="isshowavator" top="0px">
            <div class="myavator">
                <div class="title">{{$common.dicword('avatarmodify')}}</div>
                <div class="con">
                    <ffupload :fileurl="me.face" @update:fileurl="updateface" :updata="{'mediatype':'avatar'}"></ffupload>
                </div>
            </div>
        </el-dialog>
        <div class="transmask" v-if="shownavmain||shownavsub" @click="showmorenav()"></div>
    </div>
</template>

<script>
    export default {
        name: 'Cmember',
        data() {
            return {
                isload: false,
                me: {},
                mynav: [],
                mynavsub: [],
                isshowavator: false,
                listproject: [],
                indexproject: 0,
                listlevel: [],
                listsch: [],
                myoption: {
                    schoolid: -1,
                    groupid: -1,
                    projectid: -1,
                    levelid: -1,
                    courseid: -1,
                    topicid: -1,
                    lessonid: -1,
                    kw: '',
                    issch: 0,
                    schstat: 0,
                    tk: 0,
                    schid: -1,
                },
                caslevelvalue: '',
                casgroupvalue: '',
                subnavwrapwidth: 0,
                subnavrealwidth: 0,
                subnavmovex: 0,
                isnavmove: false,
                navinterval: '',
                shownavmain: false,
                shownavsub: false,
                schoollist: [],
                grouplist: [],
            };
        },
        props: {
            curnavkv: {
                type: Number,
                default: 0
            },
            navsub: {
                type: Number,
                default: 0
            },
            hassave: {
                type: Boolean,
                default: false
            },
            subtitle: {
                type: String,
                default: ''
            },
            options: {
                type: Object,
                default: () => { }
            }
        },
        computed: {
            issmall: function () {
                return this.$store.getters.issmall;
            },
            mynavsubcur: function () {
                return this.$common.basic.fffind(this.mynavsub, 'kv', this.navsub);
            },
            c_options: function () {
                let _options = {};
                let opdf = {
                    hasgroup: 0,
                    hasoption: 0,
                    hasproject: 0,
                    haslevel: 0,
                    hascourse: 0,//调用获取topic方法
                    hastopic: 0,//是否在获取course后并获取topic
                    hasdemand: 0,
                    haskw: 0,
                    projects: [],
                    anycourse: true,
                    anygroup: true,
                    anyschool: false,
                    showschool: true,
                    showgroup: true,
                    showcourse: true,
                    hassch: 0,
                    showsch: false

                }
                Object.assign(_options, opdf, this.options);
                return _options;
            },
            hasnavsub: function () {
                return this.$common.basic.isarrayexist(this.mynavsub);
            },
            hasnavpro: function () {
                return this.$common.basic.isarrayexist(this.listproject);
            },
            casoptiongroup: function () {
                return this.c_options.anygroup ? { checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' } : { expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' };
            },
            casoption: function () {
                return this.c_options.anycourse ? { checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' } : { expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' };
            },
            isshownavarrow: function () {
                return (this.subnavrealwidth > this.subnavwrapwidth) && !this.issmall;
            },
            c_navmain: function () {
                return this.$common.basic.fffind(this.mynav, 'kv', this.curnavkv);
            },
            c_navsub: function () {
                return this.$common.basic.fffind(this.mynavsub, 'kv', this.navsub);
            },
            c_subnavtop: function () {
                return this.hasnavsub ? this.c_navsub : this.listproject[this.indexproject];
            },
            c_showschool: function () {
                return this.c_options.showschool && this.schoollist.length > 1;
            },
            c_showgroup: function () {
                return this.c_options.showgroup && this.grouplist.length > 0;
            }
        },
        methods: {
            updateface: function (v) {
                this.me.face = v;
                this.$store.dispatch('setface', this.me.face);
            },
            clearoptions: function (projectid = 0, levelid = 0, courseid = 0, topicid = 0, lessonid = 0) {

                this.myoption.lessonid = lessonid > 0 ? lessonid : -1;
                this.myoption.topicid = topicid > 0 ? topicid : -1;
                this.myoption.courseid = courseid > 0 ? courseid : -1;
                this.myoption.levelid = levelid > 0 ? levelid : -1;

                this.myoption.projectid = projectid;
                if (projectid > 0) {
                    this.listlevel = [];
                }
                /*
                //this.myoption.schoolid = -1;
                //this.myoption.groupid = -1;

                if (lessonid > 0) {
                    this.myoption.lessonid = lessonid;
                }
                else {
                    this.myoption.lessonid = -1;
                    if (topicid > 0) {
                        this.myoption.topicid = topicid;
                    }
                    else {
                        this.myoption.topicid = -1;
                        if (courseid > 0) {
                            this.myoption.courseid = courseid;
                        }
                        else {
                            this.myoption.courseid = -1;
                            if (levelid > 0) {
                                this.myoption.levelid = levelid;
                            }
                            else {
                                this.myoption.levelid = -1;
                                this.myoption.projectid = projectid;
                                if (projectid > 0) {
                                    this.listlevel = [];
                                }
                            }
                        }
                    }
                }
                */

                //this.myoption.kw = '';

            },
            showsub: function (v, isforce = false) {
                this.showmorenav();
                isforce = isforce || (v != this.navsub);

                if (isforce) {
                    this.$emit('update:navsub', v);

                    this.$nextTick(function () {
                        //this.clearoptions();//不清除选项

                        this.optionsupdate();
                    });
                }
            },
            selectproject: function (v) {
                this.showmorenav();
                this.indexproject = v;
                this.clearoptions(v == -1 ? -1 : this.listproject[v].id);
                if (this.c_options.anycourse) {
                    this.optionsupdate();
                }

                if (this.c_options.hascourse) {
                    this.gettopics();
                }
            },
            selectlevel: function (v) {
                this.showmorenav();
                this.listproject[this.indexproject].x_index = v;

                this.myoption.levelid = v >= 0 ? this.listproject[this.indexproject].x_children[v].id : -1;
                this.optionsupdate();
            },
            levelchange: function (e) {
                this.$refs.caslevel.dropDownVisible = false;
                if (this.$common.basic.isarrayexist(e)) {
                    this.clearoptions(0, e[0], e.length > 1 ? e[1] : -1, e.length > 2 ? e[2] : - 1)
                    this.optionsupdate();
                }
                else {
                    this.selectproject(this.hasnavsub ? -1 : this.indexproject);
                }

            },
            projectchange: function (e) {
                this.$refs.caslevel.dropDownVisible = false;
                if (this.$common.basic.isarrayexist(e)) {
                    this.clearoptions(e[0], e.length > 1 ? e[1] : -1)
                    this.optionsupdate();
                }
                else {
                    this.selectproject(this.hasnavsub ? -1 : this.indexproject);
                }

            },
            groupchange: function (e) {
                this.$refs.casgroup.dropDownVisible = false;
                if (this.$common.basic.isarrayexist(e)) {
                    this.myoption.schoolid = e[0];
                    this.myoption.groupid = e.length > 1 ? e[1] : -1;

                }
                else {
                    this.myoption.schoolid = -1;
                    this.myoption.groupid = -1;
                }
                this.optionsupdate();//?
            },
            selectcompany: function () {
                this.myoption.groupid = -1;
                this.optionsupdate();
            },
            selectgroup: function () {
                this.optionsupdate();
            },
            selectsch: function () {
                this.optionsupdate();
            },
            optionsupdate: function () {
                this.$emit('optionsupdate', this.myoption);
            },
            gettopics: function () {
                let jsondata = {
                    'postdata': { 'act': 'tea_my_topic', 'data': { 'projectid': this.myoption.projectid, 'hasdemand': this.c_options.hasdemand, "hastopic": this.c_options.hastopic } }, 'msg': ''
                };
                this.$common.post(jsondata, res => {

                    if (this.c_options.hastopic) {
                        this.$common.each(res.infodatacourse, item => {
                            item.x_children = this.$common.basic.fffilter(res.infodatatopic, "courseid", item.id);
                        });
                    }

                    this.$common.each(res.infodatalevel, item => {
                        item.x_children = this.$common.basic.fffilter(res.infodatacourse, "levelid", item.id);

                    });


                    if (!this.c_options.anycourse) {
                        let levelid = 0;
                        let courseid = 0;
                        if (this.$common.basic.isarrayexist(res.infodatalevel)) {
                            levelid = res.infodatalevel[0].id;
                            if (this.$common.basic.isarrayexist(res.infodatalevel[0].x_children)) {
                                courseid = res.infodatalevel[0].x_children[0].id;
                            }
                        }

                        this.caslevelvalue = [levelid, courseid];
                        this.clearoptions(this.myoption.projectid, levelid, courseid);
                        this.optionsupdate();
                    }
                    this.listlevel = res.infodatalevel || [];

                });
            },
            getschs: function () {
                let jsondata = {
                    'postdata': { 'act': 'tea_op_sch' }, 'msg': ''
                };
                this.$common.post(jsondata, res => {
                    this.listsch = res.infodata;

                });
            },
            getdata: function () {
                let mydata = this.$common.basic.jsonclone(this.c_options);
                mydata.kv = this.curnavkv;
                let jsondata = {
                    'postdata': {
                        'api': 'member', 'act': 'membernavtea', 'data': mydata
                    }, 'msg': ''
                };
                this.$common.post(jsondata, res => {

                    this.isload = true;
                    this.me = res.infodatame;
                    this.mynav = res.infodatamemnav;
                    this.mynavsub = res.infodatamemnavsub;

                    if (this.c_options.hasgroup) {
                        this.$common.each(res.infodataschool, item => {
                            item.x_children = this.$common.basic.fffilter(res.infodatagroup, "companyid", item.id);
                        });

                        this.schoollist = res.infodataschool;
                        this.grouplist = res.infodatagroup;

                        this.$emit('groupupdate', this.grouplist);

                        if (!this.c_options.anyschool) {
                            if (this.$common.basic.isarrayexist(this.schoollist)) {
                                if (this.myoption.schoolid <= 0) {
                                    this.myoption.schoolid = this.schoollist[0].id;

                                    if (!this.c_options.anygroup) {
                                        this.myoption.groupid = this.schoollist[0].x_children[0].id;
                                    }
                                }
                                this.casgroupvalue = [this.myoption.schoolid];
                                if (this.myoption.groupid > 0) {
                                    this.casgroupvalue.push(this.myoption.groupid);
                                }
                            }
                        }

                    }


                    if (this.c_options.hasproject) {
                        if (this.c_options.haslevel) {

                            this.$common.each(res.infodataproject, item => {
                                item.x_children = this.$common.basic.fffilter(res.infodatalevel, "projectid", item.id);
                                item.x_index = -1;
                            });
                        }
                        this.listproject = res.infodataproject;
                        if (this.$common.basic.isarrayexist(this.listproject)) {
                            if (!this.hasnavsub) {
                                this.selectproject(0);//父组件获取数据，这是当前有选项页面在没有二级导航的情况下肯定会有项目选项
                            }
                        }

                    }
                    if (this.c_options.hascourse) {
                        this.gettopics();
                    }

                    if (this.c_options.hassch) {
                        this.getschs();
                    }

                    if (this.hasnavsub) {//&& !this.c_options.anycourse，目前不会有第一子菜单需要强制课程，暂时不考虑
                        this.showsub(this.navsub, true);//当课程必选时会触发gettopics，因为肯定是第一个子菜单，所以不需要设置navsub
                    }


                    else if (this.$common.basic.isarrayexist(this.c_options.projects)) {

                        this.listproject = this.c_options.projects;
                        this.selectproject(0);//父组件获取数据，这是当前页面在没有二级导航的情况下肯定会有项目选项
                    }

                    this.$nextTick(() => {
                        if (this.$refs.subnavwrap) {
                            this.subnavwrapwidth = this.$refs.subnavwrap.clientWidth;
                            this.subnavrealwidth = this.$refs.subnavreal.clientWidth;
                        }

                    });
                });
            },
            navmove: function (v) {


                this.isnavmove = true;
                this.navinterval = window.setInterval(() => {
                    if (this.isnavmove) {
                        this.navmovefun(v);
                    }
                    else {
                        window.clearInterval(this.navinterval);
                    }

                }, 20);

            },
            navmovefun: function (v) {
                let xmax = this.subnavrealwidth - this.subnavwrapwidth;
                let nx = this.subnavmovex + v;
                if (nx < 0) {
                    nx = 0;
                    window.clearInterval(this.navinterval);
                }
                else if (nx > xmax) {
                    nx = xmax;
                    window.clearInterval(this.navinterval);
                }
                this.subnavmovex = nx;
            },
            navmoveprev: function () {
                this.navmovefun(-100);
                return false;
            },
            navmovenext: function () {
                this.navmovefun(100);
                return false;
            },
            navmoveswipe: function (e) {
                let distance = e.timeStamp / 8000;
                if (e.direction == 'Left') {
                    this.navmovefun(distance);
                }
                else if (e.direction == 'Right') {
                    this.navmovefun(0 - distance);
                }
            },
            showmorenav: function (m = false, s = false) {
                this.shownavmain = m ? !this.shownavmain : false;
                this.shownavsub = s ? !this.shownavsub : false;
            },
            save: function () {
                this.$emit("save");
            }
        },
        mounted() {
            if (this.$common.checklogin()) {
                this.getdata();
            }
        }
    }

</script>
